<template>
	<div class="paymentRecord">
		<!--<div class="totalMoney">
			合计金额：¥{{allMoney}}，其中线上：¥{{OnlineMoney}}，线下：¥{{lineMoney}}
		</div>-->
		<div class="table">
			 <el-table
			    :data="tableData"
			    border
			    style="width: 100%">
			    <el-table-column
			      prop="orderCreateTime"
			      label="日期"
			      width="280"
			      align="center">
			      <template slot-scope="scope">
			        <span style="margin-left: 10px">{{scope.row.orderCreateTime | timestampToDate}}</span>
			      </template>
			    </el-table-column>
			    <el-table-column
			      prop="orderAmount"
			      label="金额（人民币）"
			      width="180"
			      align="center">
			    </el-table-column>
			    <el-table-column
			      label="支付方式"
			      width="180"
			      align="center">
			      <template slot-scope="scope">
			      	<span>{{scope.row.payWay | payWay}}</span>
			      </template>

			    </el-table-column>
			    <el-table-column
			      label="标题"
			      align="center">
			      <template slot-scope="scope">
			      	<span>{{scope.row.orderTitle}}</span>

			      </template>
			    </el-table-column>
			    <el-table-column
			      label="备注"
			      align="center"
			      prop="orderContent">
			    </el-table-column>
			  </el-table>
		</div>
    <div style="display: none">{{changeMatchMsg}}</div>
  </div>
</template>

<script>
	import axios from 'axios'
	import Cookie from "@/assets/js/cookie.js";
	export default{
		data(){
			return{
				allMoney:0,
				OnlineMoney:700,
				lineMoney:0,
				tableData:[],
        matchCode:''
			}
		},
    computed: {
      changeMatchMsg(){
        this.matchCode = this.$store.state.matchCodeMsg;
        this.onSubmit();
        return this.$store.state.matchCodeMsg
      }
    },
		filters: {
		    timestampToDate(data,showTime) {
		      return global.timestampToDate(data,true);
		    },
		    payWay(data) {
		      if(data==1){
		      	return data='支付宝'
		      }else if(data==2){
		      	return data="微信"
		      }
		    },
		},
		mounted(){

		},
		methods:{
      onSubmit(){
        var self=this
        var postData={
          matchCode:this.matchCode
        }
        axios.post('/marlin/sign/data/pay/order/query/list',postData)
          .then(function(res){
            if(res.data.code==0){
              self.tableData=res.data.rst
            }
          })
          .catch(function(res){
            overdue(res.response,res.response.status,self)
          })
      }
		}
	}
</script>

<style scoped lang="less">
	.table{
		margin-top: 50px;
	}
	.cell span{
		margin-left: 0 !important;
	}
</style>



// WEBPACK FOOTER //
// src/pages/paymentRecord.vue